<script setup>
import {ref} from "vue";
import Lens from '../assets/svg/lens.svg?component'

let searchWord = ref('')
let emit  = defineEmits([])

const searchData = ()=>{

    emit('search',searchWord.value)
}

</script>


<template>

    <div class="col-md-4 searchCol mt-4">
<!--        <img src="../assets/img/search-normal.svg" alt="KMS" title="KMS">-->
        <Lens
            class="position-absolute"
            style="top:24%; left: 15px;"
        />
        <input type="search" class="form-control searchInput" id="inputSearch" v-model="searchWord" @keyup.enter="searchData"   placeholder="Search..."
        >
    </div>

</template>
